import React from 'react';
import classNames from 'classnames';
import { map } from 'underscore';

export const Slider = ({ collection, active, className }) => {
    return (
        <div className={classNames('lending-categories-indicator', className)}>
            {map(collection, (item, index) => {
                return (
                    <div
                        className={classNames(
                            'lending-categories-indicator__item',
                            {
                                'lending-categories-indicator__item_active':
                                    active(item),
                            }
                        )}
                        key={index}
                    />
                );
            })}
        </div>
    );
};
